/**
 * Identifiants des onglets de panneau déclarés par le manifest skill-up.
 *
 * @remarks
 * Ici plutôt que dans `manifest.ts` : un composant qui ouvre un onglet
 * importerait sinon le manifest, et avec lui le registre et les routes — un
 * cycle qui passe par ses propres vues. Le manifest et les composants lisent
 * la même constante, ils ne peuvent plus diverger.
 */

/** Panneau droit — le parcours de la session. */
export const GRAPH_TAB_ID = 'skill-up-graph';

/** Panneau droit — les explications demandées pendant la session. */
export const LEXIQUE_TAB_ID = 'skill-up-lexique';
